import { render, staticRenderFns } from "./Monks.vue?vue&type=template&id=1c32bd09&"
import script from "./Monks.vue?vue&type=script&lang=ts&"
export * from "./Monks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports